export class UserCompany {
  id: string;
  name: string;
  fullName: string;
  domainName: string;
  lastLoginDate: string;
  isActive: boolean;
}
